var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnicalDrawingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 1.6,
    transform: "matrix(-.707 -.707 .707 -.707 24 57.941)",
    fill: "#FFA000",
    width: 14.6,
    height: 44.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9E6400"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.9,
    y: 20.2,
    transform: "matrix(-.707 -.707 .707 -.707 21.177 51.125)",
    width: 6.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3,
    y: 15.2,
    transform: "matrix(-.707 -.707 .707 -.707 29.833 44.71)",
    width: 3.7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 12.2,
    transform: "matrix(-.707 -.707 .707 -.707 40.49 43.125)",
    width: 6.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 6.3,
    transform: "matrix(.707 -.707 .707 .707 3.643 25.147)",
    width: 2,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 31.2,
    transform: "matrix(-.707 -.707 .707 -.707 -8.794 60.71)",
    width: 3.7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9,
    y: 28.2,
    transform: "matrix(-.707 -.707 .707 -.707 1.863 59.125)",
    width: 6.6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3,
    y: 23.2,
    transform: "matrix(-.707 -.707 .707 -.707 10.52 52.71)",
    width: 3.7,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalDrawingIcon);
export default __webpack_public_path__ + "static/media/technical_drawing_icon.acf3a00fc917d6e34cac36da0d603b91.svg";
export { ForwardRef as ReactComponent };